$('.footer-signup button.button').bind({
  click: function(){
    var email = $('input[name="contact[email]"').val().trim();
    var formValidation = true;

    var regexEmail = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (String(email).match(regexEmail) == null ) {
      formValidation = false;
    }

    if (formValidation){
      var auth_data = {
        email: email
      }			

      var contact_data = {
        'channels': {
          'email': {
            'subscribeStatus': 'subscribed'
          }
        },		          
        'source_create': 'footer',       
        'welcome_signup': true,
        'signup_source': 'footer'
      };

      var properties = {
        'source_create': 'footer',
        'welcome_signup': true,
        'signup_source': 'footer'
      };

      crdl([				
        ['contact', auth_data, contact_data,{'upsert': true}],
        ['event', 'email_signup', properties]
      ]);
    }
  }
});

$('#create_customer button.button').bind({
  click: function(){
    var firstName = $('input[name="customer[first_name]"]').val().trim();
    var lastName = $('input[name="customer[last_name]"]').val().trim();
    var email = $('input[name="customer[email]"]').val().trim();
    var password = $('input[name="customer[password]"]').val().trim();
    var formValidation = true;
    var signupEvent = "";
    
    var regexPassword = /^.{6,}$/;
    if ( String(password).match(regexPassword) == null ) {
      formValidation = false;
    }

    if (!email || !firstName || !lastName || !password) {
      formValidation = false;
    }

    if (!$('input[name="customer[accepts_marketing]"]').is(':checked')){
    	setTimeout(function(){ $('.footer_left').addClass('optout'); }, 4000);	
    }
    
    var loginProperties = {
      'email': email
    };
    
    if (formValidation && $('.errors').length == 0){
      var auth_data = {
        email: email
      }

      var contact_data = {
        'channels': {
            'email': {
              'subscribeStatus': 'none'
            }
        },        
        'first_name': firstName,
        'last_name': lastName,
        'source_create': 'myaccount'
      };      

      if ($('input[name="customer[accepts_marketing]"]').is(':checked')){
        var contact_data = {
          'channels': {
            'email': {
              'subscribeStatus': 'subscribed'                   
            }
          },        
          'first_name': firstName,
          'last_name': lastName,
          'source_create': 'myaccount',                         
          'welcome_signup': true,
          'signup_source': 'myaccount'
        };

        var properties = {
          "signup_source": 'myaccount',
          "welcome_signup": true
        };

        signupEvent = ['event', 'email_signup', properties];
      }

      crdl([       
        ['contact', auth_data, contact_data,{'upsert': true}],
        ['event', 'account_create'],
        ['event', 'login', loginProperties],
        signupEvent
      ]);
    }
    setTimeout(function(){verifySubscribed()}, 5000);
  }
});

// verify if customer is subscribed after account creation 
// when the default shopifysignup event (always subscribes customers)
// is completed. Sets to 'none' if not subscribed.
// This stuff is in the footer.
function verifySubscribed(){
  if ($('.active-account').attr('data-email').length > 0) {
    var email = $('.active-account').attr('data-email');

    if ($('.active-account.optout').length > 0) {
      var auth_data = {
        email: email
      }

      var contact_data = {
        'channels': {
          'email': {
            'subscribeStatus': 'none'
          }
        }
      };      

      crdl([        
        ['contact', auth_data, contact_data,{'upsert': true}]
      ]);

      $('.active-account').removeClass('optout').removeAttr("data-email").removeAttr("data-tags");
    }

    if ($('.active-account.optin').length > 0) {
      if ($('.active-account.optin').attr('data-tags') == 'myaccount') {
        var auth_data = {
          email: email
        }

        var contact_data = {
          'channels': {
            'email': {
              'subscribeStatus': 'subscribed'
            }
          },
          'signup_source': 'myaccount'
        };      

        crdl([        
          ['contact', auth_data, contact_data,{'upsert': true}]
        ]);

        $('.active-account').removeClass('optin').removeAttr("data-email").removeAttr("data-tags");
      }
    }
  }
}

//Prestige - 10052024-Homepage Update : they want a music note after text one of the hp feature slides
$( ".slideshow__slide-content .prose .h1" ).each(function( index ) {
  if ($(this).text() == "Fresh in, got your attention" ){
      $(this).append('<span style="font-size: 1.75em; padding-left: 10px;">&#9834;</span>');
      if(window.innerWidth > 767) {
        $(this).parent().css('padding-left','22%');
      } 
  }
});

$("div[id^='shopify-block-daily_deals_sales_manager_daily_deals_'] div").first().css('margin','auto');
$("div[id*='_deals_sales_manager_daily_deals_'] div").first().css('margin','auto');

//Size charts - default show size chart for the product's type
var prodType = '.' + $("button.size_chart").attr('data-product');
$("button.size_chart").click(function(){
  $(prodType).addClass('active');
});